import ChartBar, { ChartBarProps } from '@/components/KPI/ChartBar.tsx';

type CharBarKPIProps = {
  title: string;
  filterContent?: React.ReactNode;
  icon?: React.ReactNode;
  subTitle?: string;
  settings: ChartBarProps;
};

const CharBarKPI = ({
  title,
  filterContent,
  icon,
  subTitle,
  settings,
}: CharBarKPIProps) => {
  return (
    <div className="card card-flush h-lg-100 mt-5">
      <div className="card-body py-0 ps-6 mt-5">
        <div className="flex flex-wrap justify-between gap-5">
          <div className="flex flex-col align-items-start flex-column">
            <div className="flex gap-2 mb-1">
              {icon}
              <span className="card-label text-gray-800 text-lg">{title}</span>
            </div>
            <span className="text-gray-500 mt-1 fw-semibold fs-6 text-sm">
              {subTitle}
            </span>
          </div>
          <div className="max-sm:w-full">{filterContent}</div>
        </div>
        <ChartBar {...settings} />
      </div>
    </div>
  );
};

export default CharBarKPI;
